<template>
  <div class="col-lg-12 col-md-12 col-sm-12 mt-5" style="display: flex;">
    <div class="col-lg-4 col-md-4 col-sm-12">
      <b-card title="Crear nuevas transacciones">
        <b-card-body>
          <b-row class="form-group">
            <b-col>
              <input v-model="transaction.orderNumber" class="form-control" placeholder="Numero de orden">
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col>
              <b-form-datepicker placeholder="Seleccionar fecha" id="example-datepicker" v-model="transaction.dateTransaction" class="mb-2"></b-form-datepicker>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col>
              <input v-model="transaction.description" class="form-control" placeholder="Descripcion">
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col>
              <input type="number" v-model="transaction.amount" class="form-control" placeholder="Monto">
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col>
              <input type="text" v-model="transaction.status" class="form-control" placeholder="Estado">
            </b-col>
          </b-row>

        </b-card-body>
        <b-row>
          <b-col class="text-right">
            <b-button variant="primary" @click="createTransaction">Guardar</b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="col-lg-8 col-md-8 col-sm-12">
      <b-card no-body>
        <b-card-header class="border-0">
          <h3 class="mb-0">Listado de transacciones</h3>
        </b-card-header>

        <el-table v-if="tableData.length" class="table-responsive table"
                  header-row-class-name="thead-light"
                  :data="tableData">
          <el-table-column label="Numero orden"
                           min-width="170px"
                           prop="orderNumber">
            <template v-slot="{row}">
              {{ row.orderNumber }}
            </template>
          </el-table-column>

          <el-table-column label="Fecha"
                           min-width="170px"
                           prop="dateTransaction">
            <template v-slot="{row}">
              {{ row.dateTransaction }}
            </template>
          </el-table-column>

          <el-table-column label="Descripcion"
                           min-width="170px"
                           prop="description">
            <template v-slot="{row}">
              {{ row.description }}
            </template>
          </el-table-column>
          <el-table-column label="Monto"
                           min-width="170px"
                           prop="amount">
            <template v-slot="{row}">
              {{ row.amount|number }}
            </template>
          </el-table-column>
          <el-table-column label="Estado"
                           min-width="100px"
                           prop="status">
            <template v-slot="{row}">
              {{ row.status }}
            </template>
          </el-table-column>
          <el-table-column label="Opciones" min-width="100px">
            <template v-slot="{row}">
              <button class="btn btn-sm btn-outline-primary" @click="deleteItem(row._id)">
                <i class="ni ni-fat-remove"></i>
              </button>
              <button class="btn btn-sm btn-outline-primary" @click="openModal(row._id)">
                <i class="ni ni-send"></i>
              </button>
            </template>
          </el-table-column>

        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination v-model="currentPage" :per-page="20" :total="total"></base-pagination>
        </b-card-footer>
      </b-card>
    </div>
    <b-modal id="modal_update_status" hide-footer hide-header v-if="transaction_selected">
      <input type="text" class="form-control" placeholder="Ingrese el nuevo estado" v-model="transaction_selected.status">
      <button class="btn btn-primary btn-block" @click="updateItem()">ACTUALIZAR</button>
    </b-modal>
  </div>
</template>

<script>
import {get, post} from "@/util/axiosRequest";
import {Table, TableColumn} from "element-ui";

export default {
  name: "Transactions",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    formatted: '',
    transaction: {
      userId: null,
      orderNumber: null,
      dateTransaction: null,
      description: null,
      amount: null,
      discount: null,
      balance: 0,
      status: null
    },
    transaction_selected: null,
    tableData: [],
    currentPage: 1,
    total: 0
  }),
  mounted() {
    this.getTransactions()
  },
  methods: {
    createTransaction() {
      if (this.validate()) {
        this.transaction.userId = this.$route.params.id
        post('transactions/create', this.transaction, true).then(({data}) => {
          this.showMessage("Transaccion creada", "success")
          this.clear()
          this.getTransactions()
        })
      } else {
        this.showMessage("Todos los campos son requeridos", "error")
      }
    },
    validate() {
      return this.transaction.amount !== null &&
        this.transaction.dateTransaction !== null && this.transaction.balance !== null &&
        this.transaction.description !== null && this.transaction.orderNumber !== null
    },
    getTransactions() {
      get("transactions", this.$route.params.id, true).then(({data}) => {
        this.tableData = data
        let tempAmount = 0;
        let tempDiscount = 0;
        data.forEach(el => {
          tempAmount += (el.amount)
          tempDiscount += (el.discount)
        })
        this.$store.commit('setBalance', tempAmount);
        this.$store.commit('setDiscount', tempDiscount);
      })
    },
    deleteItem(id) {
      post('transactions/delete', {_id: id}, true).then(({data}) => {
        this.showMessage("Transaccion eliminda", "success")
        this.getTransactions()
      })
    },

    openModal(id){
      const model = this.tableData.find(x => x._id === id)
      this.transaction_selected = model
      this.$bvModal.show("modal_update_status")
    },

    updateItem() {
      post('transactions/update', {id: this.transaction_selected._id, status: this.transaction_selected.status}, true).then(({data}) => {
        this.clear()
        this.showMessage("Transaccion correcta", "success")
        this.getTransactions()
      })
    },
    showMessage(message, type = 'success') {
      this.$swal({
        html: message,
        icon: (type === "success") ? 'success' : 'error',
        showCloseButton: true,
        show: false,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
    },
    clear() {
      this.transaction = {
        userId: null,
        orderNumber: null,
        dateTransaction: null,
        description: null,
        amount: null,
        discount: null,
        balance: 0,
        status: null
      }
      this.transaction_selected = null
    }
  }
}
</script>

<style scoped>

</style>
